import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICdwSearchGridDataService } from '@cdw-ae/common-ui-components-search-grid';
import type {
  IGetSqlDataParams,
  SqlResponse,
} from '@cdw-ae/filter-bar-interfaces';
import { Observable } from 'rxjs';
import { ApiUrlBuilderService } from '../../../../../common/services/api-url-builder.service';

export interface AssetChangeRow {
  id: number;
  assetId: string;
  cdwAssetId: string | null;
  auditLogId: number;
  // Device fields (assetTypeId=1)
  serialNumber?: string | null;
  vendorId?: string | null;
  make?: string | null;
  model?: string | null;
  // User fields (assetTypeId=2)
  email?: string | null;
  fullName?: string | null;
  orgUnitPath?: string | null;
  isAdmin?: boolean | null;
  isSuspended?: boolean | null;
  // Grouping fields (assetTypeId=3)
  value?: string | null;
}

@Injectable()
export class AssetChangeDataService
  implements ICdwSearchGridDataService<AssetChangeRow>
{
  private auditLogId!: number;
  private assetTypeId!: number;

  constructor(
    private httpClient: HttpClient,
    private readonly urlBuilder: ApiUrlBuilderService
  ) {}

  setContext(auditLogId: number, assetTypeId: number): void {
    this.auditLogId = auditLogId;
    this.assetTypeId = assetTypeId;
  }

  public fetchSqlData(
    params: IGetSqlDataParams
  ): Observable<SqlResponse<AssetChangeRow>> {
    const url = this.urlBuilder.backendApi('audit-log', 'asset-changes/search');
    return this.httpClient.post<SqlResponse<AssetChangeRow>>(url, {
      activeFilters: params.activeFilters || [],
      startRow: params.startRow,
      endRow: params.endRow,
      supplementalFilters: params.supplementalFilters || [],
      auditLogId: this.auditLogId,
      assetTypeId: this.assetTypeId,
    });
  }
}
